// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:18:44+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            1f9fbfb00e90d309115198100029eb74
//    Signature:      eyJpdiI6IkN0NmxjcVwvWFhoXC9hWHVFclwvbk9SRXc9PSIsInZhbHVlIjoibXVVMTMrcFFjUHFzcTRtalBkeUVwXC9qY2RHdlBVTmtMXC9vM3ZzbEp4TW5xYU0xa0g5a0Z6UG9aQzdWeTFSb1JqZ2VpemJENmhNZjZPdWJncTlVM2pOQWdUWHVcL0EydHlcL1E2aVFcLzZrNFpYa1Q5ZU1mWm1RRTVKNlFMcHVLOENzRWw0VjZaenk3MVwvRHBrZWY4OXV4ejR2SGhIY3BhbjJqa2swRlwveExRM0MyT09qTXpDK3FSUWZxZE9SZXN1NTA3ck13NjhvSGJjN0tBUW55eDduZ012OUJsZmlObnlWY2dpQWJcL01OMTU2UEpPZnpXcDl6bW5DVjczY05Ed1p5UUFWbldKWTRaeU04NjZrTDlKczlhRHZoXC9vaXVxdEVEcUhcL0pZbUs4SlJwVGZWOTFaM0RpMHoxdWtaczdBR2JDNXFxSDlBMlp4Tlc2aWt0N1wvN2RBUEVocGRrWkE3RW1maGRzT0h3T2hMUTVSQkFHWHc2SVN2TzFtTDMyeXVWaDZ0Z2dcL3laUzFpNGtSYlB5NmJOTURxSlhrUT09IiwibWFjIjoiYjQ5MjU3Mjc2ZTdlMWQwNGE4YWNjNzMyOGE1ZDJmZjYwZDkwNzRkZDlkN2Q0MGFjYTdlYWI4Y2Y3NjU0YTZiZCJ9
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
